import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScrutinyPopupComponent } from '../scrutiny-popup/scrutiny-popup.component';
import * as CryptoJS from 'crypto-js';
import { FilterStateService } from '../filter-state.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';

@Component({
  selector: 'app-scrutiny',
  templateUrl: './scrutiny.component.html',
  styleUrls: ['./scrutiny.component.scss']
})
export class ScrutinyComponent implements OnInit {
  ScrutinyForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  Intake = false;
  InstId: number = 0;
  SessionNo: number = 0;
  APIService: any;
  ScrutinyTable: any[] = [];
  colrChang=false;
  CountTable: [];
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseLevel: any;
  CourseList: any;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  CountTableForApp: any[];
  inteckCount: number;
  scrutiny: string;
  scrutinyStatusArray: any;
  userPermission: any;
  UserCollege: any;
  // jsonData: any;
 constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private filterService: FilterStateService,
    private spinner: NgxSpinnerService,
  )  { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.Table = false
    this.Intake = false;
    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    let id = ''
    this.submitButton = true;
    this.editButton = false;
   this.router.events.subscribe(event => {
    if (event instanceof NavigationStart) {
      const comingFromModal = event.restoredState?.navigationId !== undefined;
      if (comingFromModal == false && !event.url.includes('/student-profile') && !event.url.includes('/scrutiny')
      && !event.url.includes('/reports')) {
        this.filterService.clearState();
      }
    }
  });
    this.ScrutinyForm = this.fb.group({
      college: new FormControl(''),
      course: new FormControl(''),
      SessionId: new FormControl(''),
    });
    const savedState = this.filterService.getState();
    const cachedTable = this.filterService.getScrutinyTable();
    if(savedState) {
      this.fetchSession(savedState.filters.sessionId); 
      this.getCourse(savedState.filters.SessionId);
      this.getClg(savedState.filters.course);
      this.ScrutinyForm.patchValue(savedState.filters); 
      savedState.filters.CgCode = savedState.filters.college;
      if (cachedTable) {

        this.ScrutinyTable = cachedTable;
        this.Table = cachedTable.length > 0;

        if (cachedTable.length > 0 && cachedTable[0].Intake === true) {
          this.Intake = true;
        } else {
          this.Intake = false;
        }
        this.ShowTable(savedState.filters, true);
      } else {
        this.ShowTable(savedState.filters, false);
      }
    }
    else {
      this.fetchSession(id);
    }
    this.getSecretData();
  }

  fetchSession(id) {
    this.spinner.show();
    const payload = {};
    this.filteredListCourse = [];
    this.filteredCollegeList  = [];
    payload['SnDefault'] = id;
    payload['SnNo'] = id; 
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
      //this.spinner.hide();
      // let  data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Information';
      // data['icon'] = 'fas fa-box-open';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);
   })
  }

  getCourse(id){
    this.Table = false;
    this.Intake = false;
    this.ScrutinyForm.controls['course'].setValue('');
    this.filteredListCourse = [];
    this.filteredCollegeList  = [];
    this.CourseList = [];
    this.spinner.show();
    this.sessionId = id
    const payload = {};
    payload['SessionId'] = id; 
    this.umsService.fetchIntakeFilter(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else{
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      //this.spinner.hide();
      // let  data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Information';
      // data['icon'] = 'fas fa-box-open';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);
   })
  }

  getClg(CoCode){
   this.ScrutinyForm.controls['college'].setValue('');
   this.spinner.show()
   this.Table = false;
   this.Intake = false;
   this.collegeList = [];
   this.filteredCollegeList = [];
   this.CoCode = CoCode;
   const selectedCourse = this.CourseList.find(
    x => x.CoCgCoCode === CoCode
  );
  if (selectedCourse) {
    this.CourseLevel = selectedCourse.CourseLevel;
  }
   if(this.userPermission[0].CgUi == 'C'){
     this.UserCollege= this.userPermission[0].CgId;
     const payload = {};
     payload['CgCode'] = this.UserCollege
     this.umsService.getCollege(payload).subscribe((res) => {
       if(res.status){
         this.spinner.hide()
         this.collegeList = res.data;
         this.filteredCollegeList = this.collegeList.slice();
       }
       else{
         this.spinner.hide()
         this.collegeList = []
         this.filteredCollegeList = []
       }
     },(ERROR: HttpErrorResponse) => {
       this.spinner.hide()
       this.collegeList = []
       this.filteredCollegeList = []
     })
   }
   else{
     this.UserCollege = ''
     const payload = {};
     payload['SessionId'] = this.sessionId; 
   payload['CoCgCoCode'] = CoCode; 
   this.umsService.fetchIntakeFilter(payload).subscribe(res => {
     if(res.status){
       this.spinner.hide()
       this.collegeList = res.data;
       this.filteredCollegeList = this.collegeList.slice();
     }
     else{
       this.spinner.hide()
       this.collegeList = []
       this.filteredCollegeList = []
     }
    
   },(ERROR: HttpErrorResponse) => {
     this.spinner.hide()
     this.collegeList = []
     this.filteredCollegeList = []
   })
   }
   
   
  }

  ShowTable(item, isBackgroundRefresh: boolean = false){
    if (!isBackgroundRefresh) {
      this.spinner.show();
    }
    this.CgCode = item.CoCgCgCode ? item.CoCgCgCode : item.CgCode;
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SessionId'] = this.sessionId;
    payload['CoCode'] = this.CoCode;
    payload['CgCode'] = item.CoCgCgCode ? item.CoCgCgCode : item.CgCode
    this.umsService.getScrutiny(payload).subscribe((res) => {
      if (!isBackgroundRefresh) {
        this.spinner.hide();
      }
      if (res.status) {
        this.Table = true;
        this.filterService.setScrutinyTable(res.data);
        this.ScrutinyTable = res.data;
        if(res.data[0]['Intake']==true){
          this.getCount();
          this.Intake = true;
        }
        else{
          this.Intake = false;
        }
        this.filterService.setState({
          filters: this.ScrutinyForm.value
        });
        this.ScrutinyHistoryTable()
      } else {
        if(res.message == 'No Data Found'){
          let  data = {}
          data['message'] = "No Data available for Scrutiny"
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ScrutinyTable = [];
          this.Intake = false;
          this.Table = false;
        }
      }
    });   
  }

  getCount() {
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SessionId'] = this.sessionId;
    payload['CoCode'] = this.CoCode;
    payload['CgCode'] = this.CgCode
    this.umsService.getScrutinyCount(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
       this.CountTable = res.data;
       this.inteckCount = res.data[0].PermittedIntake;
      } else {
        if(res.message == 'No Data Found'){
          this.CountTable = [];
        }
        
      }
     
    });
  }

  openModal(id) {
    let data = {};
    data['ScrutinyLevel'] = id.ScrutinyLevel;
    data['UserId'] = id.UserId; 
    data['ScrutinyId'] = id.ScrutinyId;
    this.dialogRef1 = this.dialog.open(ScrutinyPopupComponent, {
      disableClose: true,
      width: "600px",
      height: "280px",
      // height: 'auto', 
      data,
    });
    this.dialogRef1.afterClosed().subscribe((result) => {
      this.ngOnInit();
      // this.getData();

    });
    this.dialogRef.afterClosed().subscribe((result) => {
      this.ngOnInit();
      // this.getData();

    })
  }



  addnewrecord(e) {
    if (e === 'true') {

      this.editButton = false;
      this.submitButton = true;
      this.ScrutinyForm.reset();
    }
    else {

      this.editButton = true;
      this.submitButton = false;

    }
  }
  redirect(to): void {
    this.router.navigate([to]);
  }

  details(data) {
    // Store data in localStorage
    localStorage.setItem('ScrutinyLevel', data.ScrutinyLevel);
    localStorage.setItem('UserId', data.UserId);
    localStorage.setItem('ScrutinyId', data.ScrutinyId);
    localStorage.setItem('StudentId', data.StudentId);
    localStorage.setItem('LoginFullName', data.LoginFullName);
    localStorage.setItem('StuFirstName', data.StuFirstNameEng);
    localStorage.setItem('StuMidName', data.StuMidNameEng);
    localStorage.setItem('StuLastName', data.StuLastNameEng);
    localStorage.setItem('CoCode', data.CoCode);
    localStorage.setItem('CgCode', data.CgCode);
    localStorage.setItem('SessionId', data.SessionId);
  
    // Navigate to student-profile
    this.router.navigate(['student-profile'], {
      state: { 
        ScrutinyLevel: data.ScrutinyLevel,
        UserId: data.UserId,
        ScrutinyId: data.ScrutinyId,
        StudentId: data.StudentId,
        LoginFullName: data.LoginFullName,
        StuFirstName: data.StuFirstNameEng,
        StuMidName: data.StuMidNameEng,
        StuLastName: data.StuLastNameEng,
        CoCode: data.CoCode,
        CgCode: data.CgCode,
        SessionId: data.SessionId
      }
    });
  }
  
  approvedStudent(){
   var appCount = this.CountTable;
   const payload = {};
   payload['UserId'] = sessionStorage.getItem('userId');
   payload['SessionId'] = this.sessionId;
   payload['CoCode'] = this.CoCode;
   payload['CgCode'] = this.CgCode
   this.umsService.getScrutinyCount(payload).subscribe((res) => {
     if (res.status) {
      this.CountTableForApp = res.data;
     } else {
       if(res.message == 'No Data Found'){
         this.CountTableForApp = [];
       }
     }
    
   });

   if(this.CountTableForApp[0].PermittedIntake < this.CountTableForApp[0].Approved){
      this.colrChang = true;
   }
  }

  ScrutinyHistoryTable(){
    this.scrutiny = ''
    const payload = {};
    payload['CoCode'] =  this.CoCode;
    payload['CgCode'] =  this.CgCode;
    payload['SessionId'] =  this.sessionId;
    this.umsService.ScrutinyHistoryTable(payload).subscribe((res) => {
      this.scrutinyStatusArray = res.data[0];
      
    })
  }

  getLoginFullName(studentId: number, status: string): string {
    console.log('studentId',studentId)
    if (status === 'Submitted' || status === 'ReSubmitted') {
        return '';
    } else {
        const matchingScrutiny = this.scrutinyStatusArray?.find(scrutiny => scrutiny.StudentId == studentId && scrutiny.LoginName != null);
        return matchingScrutiny ? matchingScrutiny.LoginName : '';
    }
}
isDownloadAllowed(scrutiny: any): boolean {
  if (!scrutiny) return false;
  const loggedInUserId = parseInt(sessionStorage.getItem('userId') || '0');
  console.log(scrutiny.Status === 'APPR',scrutiny.FinalApproval == true,Number(scrutiny.LoginId) === loggedInUserId)
  return (
    scrutiny.Status === 'APPR' &&
    scrutiny.FinalApproval == true &&
    
    scrutiny.statusByUser === 'APPR'
  );
}

// downloadCertificate(studentId: any) {
//   let payload1: any = {};
//   payload1['Stuid'] = studentId;   

//   let filter: any = {
//     "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
//     "RptCode": 311,
//     "InstName": '',
//     "InstNo": this.InstId ? this.InstId : 0,
//     "ShId": '',
//     "CgCode": '',
//     "RollNo": '',
//     "Cent": '',
//     "TnCode": '',
//     "EsId": '',
//     "CsNo": '',
//     "PgBreak": '',
//     "StrId": '',
//     "StrCode": '',
//     "RgNo": '',
//     "UC": '',
//     "Ledger": '',
//     "RegnRoll": '',
//     "DsCode": '',
//     "CoCode": '',
//     "SnNo": this.SessionNo,
//     "Extra1": JSON.stringify(payload1),
//   };

//   this.umsService.setData(JSON.stringify(filter));
//   this.redirect('reports');
// }






// downloadCertificate(studentId: any) {
//   let payload1: any = {};
//   payload1['Stuid'] = studentId;   

//   let filter: any = {
//     "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
//     "RptCode": 311,
//     "InstName": '',
//     "InstNo": this.InstId ? this.InstId : 0,
//     "ShId": '',
//     "CgCode": '',
//     "RollNo": '',
//     "Cent": '',
//     "TnCode": '',
//     "EsId": '',
//     "CsNo": '',
//     "PgBreak": '',
//     "StrId": '',
//     "StrCode": '',
//     "RgNo": '',
//     "UC": '',
//     "Ledger": '',
//     "RegnRoll": '',
//     "DsCode": '',
//     "CoCode": '',
//     "SnNo": this.SessionNo,
//     "Extra1": JSON.stringify(payload1),
//   };

//   this.umsService.setData(JSON.stringify(filter));
//   this.redirect('reports');
// }

generateQRBase64(studentId: any): Promise<string> {
    this.spinner.show();
    const encryptionKey = 'abc123'; // ?? Move to env later

    // Collect required data
    const payload = {
      LoginId: parseInt(sessionStorage.getItem('userId') || '0', 10),
      RptCode: this.CourseLevel=== 'phd' ? 312 : 311,
      InstNo: this.InstId ? this.InstId : 0,
      SnNo: this.sessionId,
      //Stuid: parseInt(sessionStorage.getItem('StudentPersonalId') || '0', 10)
      Stuid: studentId
    };

    // Encrypt payload
    let encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      encryptionKey
    ).toString();

    // Make URL safe
    encryptedData = encryptedData.replace(/\//g, '~');

    // Build API URL with ?mode=qr
    const apiUrl = `${environment.serviceUrl}/abcID/generateReport/${encodeURIComponent(encryptedData)}?mode=qr`;

    return new Promise((resolve, reject) => {
      this.httpClient.get<{ success: boolean; qrBase64: string }>(apiUrl).subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.success) {
            // ?? remove "data:image/png;base64," prefix
            const cleanBase64 = res.qrBase64.replace(/^data:image\/png;base64,/, '');
            resolve(cleanBase64);
          } else {
            reject('QR generation failed');
          }
        },
        error: (err) => {
          this.spinner.hide();
          console.error('? API call failed:', err);
          reject(err);
        }
      });
    });
  }

async downloadCertificate(studentId: any) {
  try {
    this.spinner.show();
    const qrBase64 = await this.generateQRBase64(studentId);
  let payload1: any = {};
  payload1['Stuid'] = studentId; 
  payload1['QRBase64']= qrBase64;  

  let filter: any = {
    "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
    "RptCode": this.CourseLevel === 'phd' ? 312 : 311,
    "InstName": '',
    "InstNo": this.InstId ? this.InstId : 0,
    "ShId": '',
    "CgCode": '',
    "RollNo": '',
    "Cent": '',
    "TnCode": '',
    "EsId": '',
    "CsNo": '',
    "PgBreak": '',
    "StrId": '',
    "StrCode": '',
    "RgNo": '',
    "UC": '',
    "Ledger": '',
    "RegnRoll": '',
    "DsCode": '',
    "CoCode": '',
    "SnNo": this.SessionNo,
    "Extra1": JSON.stringify(payload1),
  };
console.log(filter)
  this.umsService.setData(JSON.stringify(filter));
  this.redirect('reports');
}catch (error) {
  
    console.error('Error in downloadCertificate:', error);
  } finally {
    this.spinner.hide();
  }
}
getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.InstId = res.projectPharam['ClubPartTrans'];
    });
  }
}



